import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';

import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { SapOdpLinkedService } from '../linkedservice/sap-odp.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';

@Metamodel.model({
    name: adfModelTypeMap.sapOdp.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.SapOdp_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.SapOdp_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SapOdpLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SapOdpDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public override get hasSapCdcDependency(): boolean {
        return !__IS_FABRIC_DPE__;
    }

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
